module.exports = __webpack_public_path__ + "static/media/images-05.7e5af646.png";